export const ACCEPTED = 'ACCEPTED'

export const COMPLETED = 'COMPLETED'

export const TIMED_OUT = 'TIMED_OUT'

export const REJECTED = 'REJECTED'

export const FAILED = 'FAILED'
